export default "__VITE_ASSET__C4b3A0b1__"